import {
  ADMIN_ROUTE_COMMANDS,
  ADMIN_ROUTE_PATHS,
} from 'core/constants/admin-route-paths';
import { EducationFunction } from 'core/models/cmdeb.model';
import { Role } from 'core/models/role.model';

export type PeopleListContext =
  | 'users'
  | 'students'
  | 'teachers'
  | 'supportStaff'
  | 'guardians';

export const SUPPORT_STAFF_EDUCATION_FUNCTION: EducationFunction =
  'support_staff';

export function resolvePeopleListContext(options: {
  from?: string | null;
  role?: Role | null;
  educationFunction?: EducationFunction | string | null;
}): PeopleListContext {
  if (options.from === 'supportStaff') {
    return 'supportStaff';
  }
  if (options.from === 'students') {
    return 'students';
  }
  if (options.from === 'teachers') {
    return 'teachers';
  }
  if (options.from === 'guardians') {
    return 'guardians';
  }
  if (options.role === 'STUDENT') {
    return 'students';
  }
  if (options.educationFunction === SUPPORT_STAFF_EDUCATION_FUNCTION) {
    return 'supportStaff';
  }
  if (options.role === 'TEACHER') {
    return 'teachers';
  }
  if (options.role === 'GUARDIAN') {
    return 'guardians';
  }
  return 'users';
}

export const PEOPLE_LIST_LABELS: Record<PeopleListContext, string> = {
  users: 'Usuários',
  students: 'Alunos',
  teachers: 'Professores',
  supportStaff: 'Profissionais de apoio',
  guardians: 'Responsáveis',
};

export function peopleListSingular(context: PeopleListContext): string {
  switch (context) {
    case 'students':
      return 'aluno';
    case 'teachers':
      return 'professor';
    case 'supportStaff':
      return 'profissional de apoio';
    case 'guardians':
      return 'responsável';
    default:
      return 'usuário';
  }
}

export function peopleListPath(context: PeopleListContext): string {
  if (context === 'students') {
    return ADMIN_ROUTE_PATHS.studentsList;
  }
  if (context === 'teachers') {
    return ADMIN_ROUTE_PATHS.teachersList;
  }
  if (context === 'supportStaff') {
    return ADMIN_ROUTE_PATHS.supportStaffList;
  }
  if (context === 'guardians') {
    return ADMIN_ROUTE_PATHS.guardiansList;
  }
  return ADMIN_ROUTE_PATHS.usersList;
}

export function peopleTrashPath(context: PeopleListContext): string {
  if (context === 'students') {
    return ADMIN_ROUTE_PATHS.studentsTrash;
  }
  if (context === 'teachers') {
    return ADMIN_ROUTE_PATHS.teachersTrash;
  }
  if (context === 'supportStaff') {
    return ADMIN_ROUTE_PATHS.supportStaffTrash;
  }
  if (context === 'guardians') {
    return ADMIN_ROUTE_PATHS.guardiansTrash;
  }
  return ADMIN_ROUTE_PATHS.usersTrash;
}

export function peopleListPlural(context: PeopleListContext): string {
  switch (context) {
    case 'students':
      return 'alunos';
    case 'teachers':
      return 'professores';
    case 'supportStaff':
      return 'profissionais de apoio';
    case 'guardians':
      return 'responsáveis';
    default:
      return 'usuários';
  }
}

export function peopleTrashDescriptionKey(
  context: PeopleListContext,
):
  | 'students.trash'
  | 'teachers.trash'
  | 'supportStaff.trash'
  | 'guardians.trash'
  | 'users.trash' {
  switch (context) {
    case 'students':
      return 'students.trash';
    case 'teachers':
      return 'teachers.trash';
    case 'supportStaff':
      return 'supportStaff.trash';
    case 'guardians':
      return 'guardians.trash';
    default:
      return 'users.trash';
  }
}

export function peopleListCommand(
  context: PeopleListContext,
): readonly string[] {
  if (context === 'students') {
    return ADMIN_ROUTE_COMMANDS.studentsList;
  }
  if (context === 'teachers') {
    return ADMIN_ROUTE_COMMANDS.teachersList;
  }
  if (context === 'supportStaff') {
    return ADMIN_ROUTE_COMMANDS.supportStaffList;
  }
  if (context === 'guardians') {
    return ADMIN_ROUTE_COMMANDS.guardiansList;
  }
  return ADMIN_ROUTE_COMMANDS.usersList;
}

export function peopleListFromQuery(
  context: PeopleListContext,
): { from: PeopleListContext } | undefined {
  if (context === 'users') {
    return undefined;
  }
  return { from: context };
}
